import gql from 'graphql-tag'

export default gql`
mutation createProductIngredient($required: ProductIngrReqFields! $fields: ProductIngrFields) {
	cashAssist {
		createProductIngredient(required: $required fields: $fields) {
			id
			amount
			contains
			ingredientId
			productId
			mod_ver
			ingredient {
				id
				name
				code
				group
				units
			}
		}
	}
}
`
